import React from 'react';
import { MutedPreviewOverlay, MuxPlayerWrapper as MuxPlayer } from '@bizzabo/broadcast';
import BizzaPlyr from '@bizzabo/components/BizzaPlyr';
import { VolumeMuteOutlineIcon } from '@bizzabo/icons';
import ReactionsOverlay from '../../PlayerWrappers/ReactionsOverlay';
import config from '../../../../../config/config';

const PrerecordedPlayerWrapper = ({ isMuxPlayer, videoInitProps, captions = null, isMobileApp, session }) => (
    <>
        {!isMobileApp && isMuxPlayer ? (
            <MuxPlayer
                {...videoInitProps}
                streamType={captions ? 'live' : 'll-live'}
                muxEnvKey={config?.muxEnvKey}
                MutedOverlayComponent={<MutedPreviewOverlay IconComponent={VolumeMuteOutlineIcon} />}
            >
                {
                    ({
                        isPlayerLoading,
                        videoElRef,
                        videoPlayerCls,
                        isPlayerLoaded,
                        MuxPlayerWrapper,
                        src,
                        autoplay,
                        startTime,
                        metadata,
                        isApplyClassicTheme,
                        captionsEnabled,
                        showCaptionsByDefault
                    }) => (
                        <>
                            {isPlayerLoading && <i className="prerecorded-video-spinner fa fa-spinner fa-spin fa-2x" />}
                            <MuxPlayerWrapper
                                ref={videoElRef}
                                className={videoPlayerCls}
                                style={{ display: isPlayerLoaded ? 'block' : 'none', ...(!captionsEnabled ? { '--captions-button': 'none' } : {}) }}
                                src={src}
                                streamType={captions ? 'live' : 'll-live'}
                                autoplay={autoplay}
                                startTime={startTime}
                                metadata={metadata}
                                isApplyClassicTheme={isApplyClassicTheme}
                                captionsEnabled={captionsEnabled}
                                showCaptionsByDefault={showCaptionsByDefault}
                            >
                                {captions}
                            </MuxPlayerWrapper>
                        </>
                    )
                }
            </MuxPlayer>
        ) : (
            <BizzaPlyr {...videoInitProps}>
                {
                    ({ isPlayerLoading, videoElRef, videoPlayerCls, isPlayerLoaded, PlyrVideoElementWrapper }) => (
                        <>
                            {isPlayerLoading && <i className="prerecorded-video-spinner fa fa-spinner fa-spin fa-2x" />}
                            <PlyrVideoElementWrapper
                                ref={videoElRef}
                                playsInline
                                className={videoPlayerCls}
                                crossOrigin="anonymous"
                                style={{ display: isPlayerLoaded ? 'block' : 'none' }}
                            >
                                {captions}
                            </PlyrVideoElementWrapper>
                        </>
                    )
                }
            </BizzaPlyr>
        )}
        <ReactionsOverlay activity={session} />
    </>
);

export default PrerecordedPlayerWrapper;

